export const colours = {
	black: "#000000",
	brands: {
		facebook: "#4267B2",
		google: "#4284F4"
	},
	warning: "#FFC107",
	error: "#DD2222",
	graphs: {
		info: "#FFD800",
		negative: "#E61818",
		negativeBg: "#F7B9B9",
		positive: "#11B981",
		primary: "#2196f3",
		primaryBg: "#CAE6FC",
		quaternary: "#9C27B0",
		quaternaryBg: "#E7CBEC",
		secondary: "#F57C00",
		secondaryBg: "#FDE0C2",
		tertiary: "#00BCD4",
		tertiaryBg: "#C2EFF5",
		utility: "#9C27B0"
	},
	info: "#FFBB5B",
	nonary: "#F0AD4E",
	octonary: "#B5B5B5",
	primary: "#932A47",
	quaternary: "#848484",
	quinary: "#E5E5E5",
	secondary: "#29784C",
	senary: "#F7F7F7",
	septenary: "#737373",
	success: "#11B981",
	tertiary: "#FF5A5A",
	transparent: "rgba(0, 0, 0, 0.5)",
	white: "#FFFFFF",
	buttons: {
		add:"#11B981",
		archive: "#f27216",
		delete: "#E61818",
		edit:"#11B981",
		export: "#932A47",
		send:"#932A47",
		view:"#11B981",
	},
};